<template>
  <v-container fluid class="docs mt-4">
    <v-row>
      <v-col cols="12">
        <LogicaIntervencaoCard :logicaIntervencao="logicaIntervencao"></LogicaIntervencaoCard>
      </v-col>

      <v-col cols="12">
        <IndicadorGerenciamento :logicaIntervencao="logicaIntervencao"></IndicadorGerenciamento>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LogicaIntervencaoCard from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoCard";
import IndicadorGerenciamento from "@/pages/Projeto/pages/Indicador/Gerenciamento/IndicadorGerenciamento";

export default {
  components: { LogicaIntervencaoCard, IndicadorGerenciamento },
  computed: {
    logicaIntervencao() {
      return this.$store.getters["logicaIntervencao/byId"](parseInt(this.$route.params.logicaIntervencaoId));
    },
  },

  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style src="./Impacto.scss" lang="scss"/>
